'use client';

import {
  ArrowsLeftRightIcon,
  BarcodeIcon,
  CircleHalfIcon,
  CreditCardIcon,
  QrCodeIcon,
  WalletIcon,
} from '@phosphor-icons/react';
import { PickerDrawer } from './PickerDrawer';
import type { PaymentMethodFilter, PaymentType } from '@/lib/transactions/types';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: PaymentMethodFilter;
  onSelect: (value: PaymentMethodFilter) => void;
  availableMethods: ReadonlySet<PaymentType>;
}

const ALL_OPTIONS = [
  { value: 'pix' as const, label: 'Pix', Icon: QrCodeIcon },
  { value: 'credit' as const, label: 'Crédito', Icon: CreditCardIcon },
  { value: 'debit' as const, label: 'Débito', Icon: WalletIcon },
  { value: 'boleto' as const, label: 'Boleto', Icon: BarcodeIcon },
  { value: 'transfer' as const, label: 'TED / DOC / Transferência', Icon: ArrowsLeftRightIcon },
  { value: 'other' as const, label: 'Outros', Icon: CircleHalfIcon },
];

export function PaymentMethodPickerDrawer({ open, onOpenChange, value, onSelect, availableMethods }: Props) {
  const visible = ALL_OPTIONS.filter((o) => availableMethods.has(o.value) || o.value === value);
  return (
    <PickerDrawer<PaymentMethodFilter>
      open={open}
      onOpenChange={onOpenChange}
      title="Forma de pagamento"
      options={[
        { value: null, label: 'Todas', Icon: CircleHalfIcon },
        ...visible,
      ]}
      value={value}
      onSelect={onSelect}
      onClear={value ? () => onSelect(null) : undefined}
    />
  );
}
